<script>
  import gql from 'graphql-tag'

  export default {
    props: ['gid'],
    apollo: {
      settings: {
        query: gql`query($gid: ID) {
          merchant(gid: $gid) { merchantUser {settings {pay {requireInvoiceConfirmation}}}}
        }`,
        variables() {
          return {
            gid: this.gid
          }
        },
        update: data => data.merchant.merchantUser.settings.pay
      }
    },
    data() {
      return {
        settings: {}
      }
    },
    methods: {
      switchIt() {
        this.$apollo.mutate({
          // Query
          mutation: gql`mutation ($requireInvoiceConfirmation: Boolean!, $gid: ID) {
            updateRequiredInvoiceConfirmation(input: {requireInvoiceConfirmation: $requireInvoiceConfirmation, userId: $gid}) {
              paySettings { requireInvoiceConfirmation }
            }
          }`,
          // Parameters
          variables: {
            requireInvoiceConfirmation: !this.settings.requireInvoiceConfirmation,
            gid: this.gid
          },
        }).then(result => {
          this.settings.requireInvoiceConfirmation = result.data.updateRequiredInvoiceConfirmation.paySettings.requireInvoiceConfirmation
          this.notifySuccess("Pay settings successfully updated")
        }, error => {
          this.gqlErrorHandler(error)
          this.settings.requireInvoiceField = !this.settings.requireInvoiceField
        })
      }
    }
  }
</script>

<template>
  <div>
    <section>
      <div class= "very-close-lines">
        Require invoice confirmation:<br>
        
        <small class="grey-text">
          Enables double entry for the invoice number
        </small>
      </div>
      <!-- Switch -->
      <div class="switch">
        <label>
          Off
          <input type="checkbox" @click='switchIt' v-model='settings.requireInvoiceConfirmation' :disabled="$apollo.loading">
          <span class="lever"></span>
          On
        </label>
      </div>
    </section>
  </div>
</template>
